// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'align-item-down-solid';

export const Component = () => (
  <path d='M15.223 6.891h3.928c.431 0 .766.144 1.054.432.287.287.43.622.43 1.054v11.78c0 .432-.143.767-.43 1.055a1.408 1.408 0 0 1-1.054.431h-3.928c-.43 0-.766-.144-1.005-.431a1.408 1.408 0 0 1-.431-1.054V8.377c0-.432.143-.767.431-1.054.239-.288.575-.432 1.005-.432ZM3.97 2.485v17.673c0 .431.143.766.431 1.054a1.41 1.41 0 0 0 1.054.431H9.38a1.41 1.41 0 0 0 1.054-.431 1.58 1.58 0 0 0 .383-1.054V2.485a1.58 1.58 0 0 0-.383-1.054A1.408 1.408 0 0 0 9.381 1H5.454c-.431 0-.766.144-1.054.431a1.408 1.408 0 0 0-.431 1.054Zm19.11 21.074H1.526c-.336 0-.527.191-.527.526s.191.48.527.48h21.551c.335 0 .527-.145.527-.48 0-.335-.192-.526-.527-.526Z' />
);

export const viewBox = '0 0 25 25';
